'use strict';

module.exports = paragraph;

var all = require('../all');

function paragraph(h, node) {
  return h(node, 'paragraph', all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/paragraph.js
// module id = 1029
// module chunks = 0